<template lang="pug">
  .wrap.static
    form(@submit.prevent="signIn")
      .main
        .main-inner
          .panel-title
            h2
              img(:src="siteLogoBlue()" :alt="siteName()")
          .panel
            p
              span.panel-label
                | メールアドレス
              input(type="email" v-model="email" placeholder="foo@example.com", :disabled="locked")
            p
              span.panel-label
                | パスワード
              input(type="password" v-model="password" placeholder="password", :disabled="locked")
            p
              label.checkbox
                input(type='checkbox' v-model="sessionKeeping")
                span ログイン状態を保存する
            ErrorMessage(:errors="errors" name="system")
            p.buttons
              input.button-main(type="submit", value="ログインする", :disabled="disabled")
          p.panel-note
            router-link(:to="{ name: 'ForgotPassword' }") パスワードを再設定されたい方はこちら

    MessageToast

    footer.footer
      p.copyright
        | &copy; {{ copyright() }}
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { HumanErrorMessages, HumanInfoMessages } from '../constants'
  import ErrorMessage from './parts/ErrorMessage'
  import MessageToast from './parts/MessageToast'

  export default {
    components: { ErrorMessage, MessageToast },
    async asyncData ({ store }) {
      await store.dispatch('session/prepare')
    },
    beforeCreate () {
      const flashMessage = this.$route.query.flash_message
      if (flashMessage === 'success') {
        this.$store.dispatch('common/pushToastInfo', {
          info: HumanInfoMessages.SUCCESS_UNLOCK,
        })
      } else if (flashMessage === 'invalid') {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.EXPIRED_TOKEN),
        })
      } else if (flashMessage) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.UNKNOWN),
        })
      }
    },
    data () {
      return {
        email: '',
        password: '',
        sessionKeeping: false,
      }
    },
    computed: {
      ...mapState({
        errors: state => state.session.signIn.errors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
      }),
      disabled () {
        return this.locked || !this.email || !this.password
      },
    },
    methods: {
      async signIn () {
        this.$store.commit('common/lockGlobal')
        const { email, password, sessionKeeping } = this
        try {
          await this.$store.dispatch('session/signIn', { email, password, sessionKeeping })
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else if (!this.$store.state.user.detail.has_basic) {
            this.$router.push({ name: 'SearchStartingBusiness' })
          } else {
            this.$router.push({ name: 'SearchJob' })
          }
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/SignIn.vue